<template>
  <div
    id="main-grid"
    class="grid simple main borderRadius12px"
    style="background: #e5e9ec"
  >
    <div class="well form-group" style="background: #e5e9ec">
      <!--title -->
      <div class="grid-title no-border borderTop" style="display: flex; justify-content: space-between; align-items: center; padding-right: 20px;">
        <h4 style="padding-left: 6px"> {{ i18nValues["orderAdministration"] }} </h4>
        <el-button v-if="componentsMap.get('order_create')"
          icon="fas fa-plus"
          size="small"
          class="btn-primary"
          @click="add()"
        >
          {{ i18nValues["addOrder"] }}
        </el-button>
      </div>
      <!-- card body -->
      <div class="grid-body no-border borderBottom">

        <el-form v-loading="loading != 0">
          <div class="filters-wrapper">
            <div class="filters-row">
              <!-- search by Id -->
              <el-form-item :label="i18nValues['orderNumber']" prop="id">
                <el-input v-model="filter.id" :placeholder="i18nValues['orderNumber']"></el-input>
              </el-form-item>

              <!-- search by Status -->
              <el-form-item :label="i18nValues['status']" prop="status">
                <el-select v-model="filter.status" :placeholder="i18nValues['status']" clearable>
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>

              <!-- search by Dispatch Type -->
              <el-form-item :label="i18nValues['dispatchType']" prop="dispatchType">
                <el-select v-model="filter.dispatchType" :placeholder="i18nValues['dispatchType']" clearable>
                  <el-option
                    v-for="item in dispatchOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              
              <!-- search by Creation Date -->                
              <el-form-item :label="i18nValues['from']" prop="dispatchDateSince">
                <div class="input-group">
                  <el-date-picker 
                      v-model="filter.dispatchDateSince"
                      type="date" 
                      format="dd/MM/yyyy"
                      :clearable="true"
                      :placeholder="i18nValues['from']">
                  </el-date-picker>
                  <span class="input-group-addon primary el-input__suffix icon">
                    <span class="arrow"></span>
                    <i class="fa fa-calendar-alt"></i>
                  </span>                                
                </div>
              </el-form-item>   

              <!-- search by Creation Date Until -->                
              <el-form-item :label="i18nValues['to']" prop="dispatchDateUntil">
                <div class="input-group">
                  <el-date-picker 
                      v-model="filter.dispatchDateUntil"
                      type="date" 
                      format="dd/MM/yyyy"
                      :clearable="true"
                      :placeholder="i18nValues['to']">
                  </el-date-picker>
                  <span class="input-group-addon primary el-input__suffix icon">
                    <span class="arrow"></span>
                    <i class="fa fa-calendar-alt"></i>
                  </span>                                
                </div>
              </el-form-item>    

              <!-- search button -->
              <el-button
                @click="retrieveOrdersBySearch()"
                icon="fas fa-search"
                id="searchButton"
                size="small"
                class="btn-primary"
              >
                {{ i18nValues["search"] }}
              </el-button>
            </div>
          </div>

          <!-- table -->
          <div class="full-width" style="margin:0 auto;padding:20px;">
            <el-table
            :data="OrdersSubList"
            class="table table-hover"
            stripe
            id="OrdesTable"
            align="center"
            :empty-text="i18nValues['noDataAvailable']"
            :default-sort="tableDefaultSort"
            @sort-change="handleSortChange"
          >
          <!-- 1. N° Orden (Order Number) -->
          <el-table-column
              prop="loadingOrder.id"
              :label="i18nValues['orderNumber']"
              width="40"
              align="left"
              sortable
          ></el-table-column> 

          <!-- 2. Cantidad (Pallets Quantity) -->
          <el-table-column
              :label="i18nValues['quantity']"
              prop="palletsAmount"
              width="34"
              align="right"
              sortable
          ></el-table-column>

          <!-- 3. Estado (Status) -->
          <el-table-column
              prop="loadingOrder.status"
              :label="i18nValues['status']"
              width="30"
              align="center"
              sortable
          ></el-table-column>            

          <!-- 4. Tipo (Dispatch Type) -->
          <el-table-column
              :label="i18nValues['type']"
              prop="loadingOrder.dispatchType"
              width="30"
              align="center"
              sortable
          ></el-table-column>           

          <!-- 5. Container (Container/AWB) -->
          <el-table-column 
              prop="containerDisplay"
              :formatter="containerAWB"
              :label="i18nValues['container']"
              width="45"
              align="left"
              sortable
          ></el-table-column>   

          <!-- 6. Buque (Vessel) -->
          <el-table-column
              :label="i18nValues['vessel']"
              prop="loadingOrder.vessel"
              width="30"
              align="center"
              sortable
          ></el-table-column>  

          <!-- 7. Fecha de carga (Dispatch Date) -->
          <el-table-column
              :label="i18nValues['dispatchDate']"
              prop="loadingOrder.dispatchDate"
              width="48"
              :formatter="formatDispatchDate"
              align="center"
              sortable
          ></el-table-column>  

          <!-- EDIT/DELETE -->
          <el-table-column width="90" align="right">
                    <template slot-scope="scope">
                      <el-button
                      v-if="isReadOnly()"
                      fixed="right"
                      class="text-info"
                      icon="fa fa-eye"
                      size="small"
                      :title="i18nValues['view']"
                      @click="edit(scope.row.loadingOrder.id)"
                    ></el-button>
                    
                      <el-button v-if="componentsMap.get('order_modification')"
                        class="text-info"
                        icon="fas fa-edit"
                        size="small"
                        :title="i18nValues['edit']"
                        @click="edit(scope.row.loadingOrder.id)"
                      ></el-button>

                      <el-button v-if="componentsMap.get('orderscope.row.loadingOrder.id_delete') && (scope.row.status == 'Abierto' || scope.row.status == 'Para Despachar')"
                        class="text-danger"
                        icon="fas fa-times"
                        size="small"
                        :title="i18nValues['remove']"
                        @click="deleteOrder(scope.row.loadingOrder.id)"
                      ></el-button>
                    </template>
            </el-table-column>          
          </el-table>  
          <div v-if="90 > 10" style="height: 15px"></div>
          <div class="pagination-bar">
            <PaginationFunctional
              ref="pagination"
              sublistName="OrdersSubList"
              :fullList="OrdersList"
              :tableSize="20"
              :tableIndexInitial="initialPage"
              @paginationChange="paginationChange"
              @currentIndexPagination="setCurrentPage"
              class="text-center"
            />
            <div v-if="OrdersList.length > 0" class="results-info">
              <p>
                {{ i18nValues["showing"] || "Showing" }} {{ startIndexDisplay }}–{{ endIndexDisplay }} {{ i18nValues["of"] || "of" }} {{ totalRecords }} {{ i18nValues["results"] || "results" }}
              </p>
            </div>
          </div>
          </div>

        </el-form>

      </div>
    </div>
  </div>
</template>
  
<script>
import { sync, get } from "vuex-pathify"; // eslint-disable-line no-unused-vars
import PaginationFunctional from "@/components/PaginationFunctional.vue"
export default {
  name: "OrdersAdmin",
  created() {
    this.restoreFromQuery();
  },

  components: {
    PaginationFunctional 
  },

  computed: {
    loading: get("order/loading"),
    globalFieldSite: get("globalFieldSite"),
    globalCampaign: get("globalCampaign"),

    dispatchOptions() {
      return [
        { value: "plane", label: this.i18nValues["aerial"] },
        { value: "ship", label: this.i18nValues["maritime"] },
      ];
    },

    options() {
        return [
          { value: 'open', label: this.i18nValues["open"] },
          { value: 'forDispatch', label: this.i18nValues["forDispatch"] },
          { value: 'dispatched', label: this.i18nValues["dispatched"] },
          { value: 'inPort', label: this.i18nValues["inPort"] },
          { value: 'arrivedToDestination', label: this.i18nValues["arrivedToDestination"] },
        ];
    },

    // Pagination helpers for results label
    currentPage() {
      if (this.$refs && this.$refs.pagination && this.$refs.pagination.tableIndex) {
        return this.$refs.pagination.tableIndex;
      }
      return this.initialPage || 1;
    },
    pageSize() {
      return 20; // Keep in sync with PaginationFunctional :tableSize
    },
    totalRecords() {
      if (Array.isArray(this.OrdersList)) {
        return this.OrdersList.length;
      }
      return typeof this.cantidad === "number" ? this.cantidad : 0;
    },
    startIndexDisplay() {
      if (this.totalRecords === 0) return 0;
      const start = (this.currentPage - 1) * this.pageSize + 1;
      return Math.min(start, this.totalRecords);
    },
    endIndexDisplay() {
      if (this.totalRecords === 0) return 0;
      const end = this.currentPage * this.pageSize;
      return Math.min(end, this.totalRecords);
    },

    tableDefaultSort() {
      if (this.sortProp && this.sortOrder) {
        return { prop: this.sortProp, order: this.sortOrder };
      }
      return {};
    },
  },

  props:{
    componentsMap: {},
  },

  watch: {
    globalFieldSite: {
      immediate: true,
      handler(newVal, oldVal) {
        if (!newVal || !newVal.id) return;
        if (oldVal && oldVal.id === newVal.id) return;
        this.requestGeneration++;
        // Reset filters only when context actually changes (not on initial load)
        if (oldVal && oldVal.id) {
          this.filter.id = null;
          this.filter.status = null;
          this.filter.dispatchType = null;
          this.filter.dispatchDateSince = null;
          this.filter.dispatchDateUntil = null;
        }
        this.fetchOrders(true);
        this.retrieveOrderCount();
      },
    },
    globalCampaign: {
      immediate: true,
      handler(newVal, oldVal) {
        if (!this.globalFieldSite || !this.globalFieldSite.id) return;
        if (newVal && oldVal && newVal.id === oldVal.id) return;
        this.fetchOrders(true);
        this.retrieveOrderCount();
      },
    },
  },
  
  data() {
    const q = this.$route ? this.$route.query || {} : {};
    return {    
      filter: {
        id: q.id || null,
        status: q.status || null,
        dispatchType: q.dispatchType || null,
        dispatchDateSince: q.dispatchDateSince ? this.coerceDate(q.dispatchDateSince) : null,
        dispatchDateUntil: q.dispatchDateUntil ? this.coerceDate(q.dispatchDateUntil) : null,
        fieldSiteId: null,
        campaignId: null,
      },
      OrdersList: [],    
      OrdersSubList: [],
      originalOrdersList: [],
      cantidad: 100,
      initialPage: q.page ? Number(q.page) : 1,
      sortProp: q.sortProp || null,
      sortOrder: q.sortOrder || null,
      requestGeneration: 0,
    };
  },
  methods: {
    add(){
      this.$router.push({
        name: `OrdersEdition`,
        params: { id: "0" },
        query: this.$route.query,
      });
    },

    edit(id) {
      this.$router.push({
        name: `OrdersEdition`,
        params: { id: id },
        query: this.$route.query,
      });
    },

    deleteOrder(id) {
      this.$confirm('Está seguro que quiere eliminar la orden?', 'Eliminar Orden' , {
          distinguishCancelAndClose: true,
          confirmButtonText: 'Eliminar',
          cancelButtonText: 'Cancelar',
          type: 'warning',
        }).then(() => {
            this.$store.dispatch("order/deleteOrder" , id).then((res)=>{
              if (res.status == "OK") {
                this.$notify.success({
                  title: this.i18nValues["success"],
                  message: this.i18nValues["orderDeleted"],
                  position: "bottom-right",
                });
                // Preserve current filters, sort and page after delete
                this.fetchOrders(true);
                this.retrieveOrderCount();
              } else {
                this.$notify.error({
                  title: this.i18nValues["error"],
                  message: this.i18nValues["cantDeleteOrder"],
                  position: "bottom-right",
                });
              }       
            });
          })
    },

    fetchOrders(preservePage) {
      if (!this.globalFieldSite || !this.globalFieldSite.id) {
        this.OrdersList = [];
        this.OrdersSubList = [];
        this.originalOrdersList = [];
        return;
      }
      const gen = this.requestGeneration;
      const payload = this.buildOrderFilterPayload();
      this.$store.dispatch("order/retrieveOrdersBySearch", payload).then((res) => {
        if (gen !== this.requestGeneration) return;
        if (!res || res.length === 0) {
          this.OrdersList = [];
          this.OrdersSubList = [];
          this.originalOrdersList = [];
          this.syncRouteFromState();
          return;
        }
        for (var i = 0; i < res.length; i++) {
          this.translate(res[i]);
          res[i].containerDisplay = this.containerAWB(res[i]);
        }
        this.originalOrdersList = res;
        // Apply current sort
        if (this.sortProp && this.sortOrder) {
          const dir = this.sortOrder === "descending" ? -1 : 1;
          this.OrdersList = [...res].sort((a, b) => {
            const aVal = this.getNestedValue(a, this.sortProp);
            const bVal = this.getNestedValue(b, this.sortProp);
            if (aVal == null && bVal == null) return 0;
            if (aVal == null) return 1;
            if (bVal == null) return -1;
            return String(aVal).localeCompare(String(bVal), undefined, { sensitivity: "base" }) * dir;
          });
        } else {
          this.OrdersList = res;
        }
        if (!preservePage) this.initialPage = 1;
        this.syncRouteFromState();
        this.$nextTick(() => {
          const page = preservePage ? (this.initialPage || 1) : 1;
          if (this.$refs.pagination && typeof this.$refs.pagination.currentChange === "function") {
            this.$refs.pagination.currentChange(page);
          }
        });
      });
    },

    retrieveOrdersBySearch() {
      this.fetchOrders(false);
    },

    retrieveAllOrders(){
      if (!this.globalFieldSite || !this.globalFieldSite.id) {
        this.OrdersList = [];
        this.OrdersSubList = [];
        return;
      }
      const payload = this.buildOrderFilterPayload();
      this.$store.dispatch("order/retrieveAllOrders" , payload).then((res)=>{
        this.OrdersList = res;
        // Clear sublist immediately if list is empty to show "no data available"
        if (!res || res.length === 0) {
          this.OrdersSubList = [];
        }
        for(var i = 0; i < this.OrdersList.length; i++){
          const order = this.OrdersList[i];
          this.translate(order);
          // Pre-compute display value used for sorting and showing in the Container/AWB column
          order.containerDisplay = this.containerAWB(order);
        }
      });
    },

    buildOrderFilterPayload(overrides = {}) {
      const baseFilter = this.filter || {};
      const payload = {
        id: this.normalizeFilterValue(baseFilter.id, true),
        status: this.normalizeFilterValue(baseFilter.status),
        dispatchType: this.normalizeFilterValue(baseFilter.dispatchType),
        dispatchDateSince: this.normalizeDateValue(baseFilter.dispatchDateSince),
        dispatchDateUntil: this.normalizeDateValue(baseFilter.dispatchDateUntil),
        fieldSiteId:
          this.globalFieldSite && this.globalFieldSite.id
            ? this.globalFieldSite.id
            : null,
        campaignId:
          this.globalCampaign && this.globalCampaign.id
            ? this.globalCampaign.id
            : null,
      };
      return Object.assign({}, payload, overrides || {});
    },

    getNestedValue(obj, path) {
      if (!obj || !path) return null;
      return path.split(".").reduce((acc, key) => (acc != null ? acc[key] : null), obj);
    },

    normalizeFilterValue(value, allowNumbers = false) {
      if (value === undefined || value === null) {
        return null;
      }
      if (typeof value === "string") {
        const trimmed = value.trim();
        return trimmed === "" ? null : trimmed;
      }
      if (allowNumbers && typeof value === "number") {
        return Number.isNaN(value) ? null : value;
      }
      return value;
    },

    normalizeDateValue(value) {
      if (!value) {
        return null;
      }
      if (value instanceof Date) {
        const timestamp = value.getTime();
        return isNaN(timestamp) ? null : timestamp;
      }
      if (typeof value === "number") {
        return Number.isNaN(value) ? null : value;
      }
      const parsed = new Date(value);
      const parsedTime = parsed.getTime();
      return isNaN(parsedTime) ? null : parsedTime;
    },

    formatDispatchDate(row) {
      return this.formatDate(row.loadingOrder.dispatchDate);
    },    

    containerAWB(row){
      // Check for plane/aerial (original value or translated)
      if(row.loadingOrder.dispatchType == "plane" || 
         row.loadingOrder.dispatchType == "Aéreo" ||
         row.loadingOrder.dispatchType == this.i18nValues['aerial']){
        return row.loadingOrder.airGuide;
      }  
      // Check for ship/maritime (original value or translated)
      if(row.loadingOrder.dispatchType == 'ship' || 
         row.loadingOrder.dispatchType == "Marítimo" ||
         row.loadingOrder.dispatchType == this.i18nValues['maritime']){
        return row.loadingOrder.container;
      }
      // Return empty string if no match
      return '';
    },

    translate(order){
      var item = order.loadingOrder
      if(item.status == "open"){
        item.status = this.i18nValues['open'];
      }
      if(item.status == "forDispatch"){
        item.status = this.i18nValues['forDispatch'];
      }
      if(item.status == "dispatched"){
        item.status = this.i18nValues['dispatched'];
      }
      if(item.status == "inPort"){
        item.status = this.i18nValues['inPort'];
      }
      if(item.status == "arrivedToDestination"){
        item.status = this.i18nValues['arrivedToDestination'];
      }
      if(item.dispatchType == "plane"){
        item.dispatchType = this.i18nValues['aerial'];
      }    
      if(item.dispatchType == "ship"){
        item.dispatchType = this.i18nValues['maritime'];
      }  
    },

    retrieveOrderCount() {
      if (!this.globalFieldSite || !this.globalFieldSite.id) return;
      const gen = this.requestGeneration;
      const filter = {
        fieldSiteId: this.globalFieldSite.id,
        campaignId: this.globalCampaign ? this.globalCampaign.id : null
      };
      this.$store
        .dispatch("order/countOrders", filter)
        .then((res) => {
          if (gen !== this.requestGeneration) return;
          this.cantidad = res;
        });
    },

    handleSortChange(event) {
      const nextProp = event && event.prop ? event.prop : null;
      const nextOrder = event && event.order ? event.order : null;
      if (this.sortProp === nextProp && this.sortOrder === nextOrder) return;
      this.sortProp = nextProp;
      this.sortOrder = nextOrder;

      const currentPage = this.$refs.pagination && this.$refs.pagination.tableIndex
        ? this.$refs.pagination.tableIndex
        : this.initialPage || 1;
      this.initialPage = currentPage;

      if (this.sortProp && this.sortOrder && this.originalOrdersList.length) {
        const dir = this.sortOrder === "descending" ? -1 : 1;
        this.OrdersList = [...this.originalOrdersList].sort((a, b) => {
          const aVal = this.getNestedValue(a, this.sortProp);
          const bVal = this.getNestedValue(b, this.sortProp);
          if (aVal == null && bVal == null) return 0;
          if (aVal == null) return 1;
          if (bVal == null) return -1;
          return String(aVal).localeCompare(String(bVal), undefined, { sensitivity: "base" }) * dir;
        });
      } else {
        this.OrdersList = [...this.originalOrdersList];
      }

      this.syncRouteFromState();
      this.$nextTick(() => {
        if (this.$refs.pagination && typeof this.$refs.pagination.currentChange === "function") {
          this.$refs.pagination.currentChange(currentPage);
        }
      });
    },

    paginationChange(evt) {
      if (evt && evt.list) {
        this.OrdersSubList = evt.list;
      }
      this.syncRouteFromState();
    },

    setCurrentPage(idx) {
      if (typeof idx === "number") {
        this.initialPage = idx;
        this.syncRouteFromState();
      }
    },

    // --- Query sync helpers ---
    restoreFromQuery() {
      const q = this.$route.query || {};
      this.filter.id = q.id || null;
      this.filter.status = q.status || null;
      this.filter.dispatchType = q.dispatchType || null;
      this.filter.dispatchDateSince = q.dispatchDateSince ? this.coerceDate(q.dispatchDateSince) : null;
      this.filter.dispatchDateUntil = q.dispatchDateUntil ? this.coerceDate(q.dispatchDateUntil) : null;
      if (q.page) this.initialPage = Number(q.page);
      if (q.sortProp) this.sortProp = q.sortProp;
      if (q.sortOrder) this.sortOrder = q.sortOrder;
    },

    syncRouteFromState() {
      const q = {};
      if (this.filter.id) q.id = this.filter.id;
      if (this.filter.status) q.status = this.filter.status;
      if (this.filter.dispatchType) q.dispatchType = this.filter.dispatchType;
      if (this.filter.dispatchDateSince) q.dispatchDateSince = this.serializeDate(this.filter.dispatchDateSince);
      if (this.filter.dispatchDateUntil) q.dispatchDateUntil = this.serializeDate(this.filter.dispatchDateUntil);
      const page = this.$refs.pagination && this.$refs.pagination.tableIndex
        ? this.$refs.pagination.tableIndex
        : this.initialPage || 1;
      if (page && page > 1) q.page = String(page);
      if (this.sortProp) q.sortProp = this.sortProp;
      if (this.sortOrder) q.sortOrder = this.sortOrder;
      if (this.globalFieldSite && this.globalFieldSite.id) q.fieldSiteId = String(this.globalFieldSite.id);
      if (this.globalCampaign && this.globalCampaign.id) q.campaignId = String(this.globalCampaign.id);
      // Only navigate if query actually changed
      const current = this.$route.query || {};
      const keys = new Set([...Object.keys(q), ...Object.keys(current)]);
      let same = true;
      for (const k of keys) {
        if (String(q[k] || "") !== String(current[k] || "")) { same = false; break; }
      }
      if (!same) {
        this.$router.replace({ query: q }).catch(() => {});
      }
    },

    serializeDate(value) {
      const dt = this.coerceDate(value);
      if (!dt) {
        return undefined;
      }
      const y = dt.getFullYear();
      const m = `${dt.getMonth() + 1}`.padStart(2, "0");
      const day = `${dt.getDate()}`.padStart(2, "0");
      return `${y}-${m}-${day}`;
    },

    parseDate(value) {
      return this.coerceDate(value);
    },

    coerceDate(value) {
      if (value === null || value === undefined || value === "") {
        return null;
      }
      if (value instanceof Date) {
        return isNaN(value.getTime()) ? null : value;
      }
      if (typeof value === "number") {
        const fromNumber = new Date(value);
        return isNaN(fromNumber.getTime()) ? null : fromNumber;
      }
      if (typeof value === "string") {
        const trimmed = value.trim();
        if (!trimmed) {
          return null;
        }
        const parts = trimmed.match(/^(\d{4})-(\d{2})-(\d{2})$/);
        if (parts) {
          const year = Number(parts[1]);
          const month = Number(parts[2]) - 1;
          const day = Number(parts[3]);
          const localDate = new Date(year, month, day);
          return isNaN(localDate.getTime()) ? null : localDate;
        }
        const parsed = new Date(trimmed);
        return isNaN(parsed.getTime()) ? null : parsed;
      }
      return null;
    },
  },
};
</script>
  
<style scoped>
/* Filters wrapper - single horizontal line */
.filters-wrapper {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.filters-row {
  display: flex;
  flex-wrap: nowrap;
  align-items: flex-end;
  gap: 8px;
}

.filters-row /deep/ .el-form-item {
  margin-bottom: 0;
  flex-shrink: 0;
}

/* Make inputs narrower */
.filters-row /deep/ .el-input,
.filters-row /deep/ .el-select {
  width: 140px;
}

/* Date picker slightly wider */
.filters-row /deep/ .el-date-editor {
  width: 150px;
}


/* Buttons in the same row, aligned to bottom */
.filters-row /deep/ .el-button {
  flex-shrink: 0;
}

/* Pagination + results inline */
.pagination-bar {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  padding: 0 20px 10px;
  color: #606266;
}

.results-info {
  display: flex;
  align-items: center;
  padding: 0;
  margin: 0;
}

.results-info p {
  margin: 0;
  font-size: 12px;
  color: #606266;
  font-weight: 500;
}
</style>
  